import { ModalSize } from '../content/ItemType';
const DEFAULT_MODAL_SIZE = ModalSize.Fullscreen;
export const convertModalSizeFromServerModel = (properties) => { var _a; return (_a = properties === null || properties === void 0 ? void 0 : properties.modalSize) !== null && _a !== void 0 ? _a : DEFAULT_MODAL_SIZE; };
